import React from "react";
import { Card } from "react-bootstrap";
import "../App.css";

export default function CustomCard({ image, title, children, className = "", imgClassName = "", titleClassName = "" }) {
  return (
    <Card className={`custom-card ${className}`}>
      {image && (
        <Card.Img variant="top" src={image} className={`custom-card-img ${imgClassName}`} />
      )}
      <Card.Body >
        {title && (
          <Card.Title as="h5" className={`custom-card-title ${titleClassName}`}>
            {title}
          </Card.Title>
        )}
        {children}
      </Card.Body>
    </Card>
  );
}